export default __webpack_public_path__ + "static/media/service2.ab38a1ce.png";